<app-e-signing-page-header
	[status]="envelopeStatus_()"
	[envelopeName]="envelope_()?.packageName || packageName_()"
	[envelopeId]="envelopeId_()"
	(envelopeNameChange)="onEnvelopeNameChange($event)"
/>
@switch (envelopeStatus_()) {
	@case (STATUSES.LOADING) {
		<div class="flex h-full w-full items-center justify-center p-4">
			<i-tabler name="loader-2" class="animate-spin text-gray-950"></i-tabler>
		</div>
	}
	@case (STATUSES.DRAFT) {
		<app-envelope-draft
			[recipients_]="participatingRecipients_()"
			[eSigningBlocks_]="envelope_()?.signedElements"
			[pages_]="envelope_()?.pagesAsImages"
			(eSigningBlockChange)="eSigningBlockChangeHandler($event)"
			[envelopeId_]="envelopeId_()"
			[isSignatureDrawOnly_]="envelope_()?.isSignatureDrawOnly"
			(isSignatureDrawOnly_Change)="onSetIsSignatureDrawOnly($event)"
			(editSigners_)="editSignersHandler()"
			(tabChanged_)="onTabChanged($event)"
			[isSnapshotting_]="isSnapshotting_()"
		/>
	}
	@default {
		<app-envelope-view
			class="overflow-y-auto"
			[matterId_]="matterId_()"
			[envelopeStatus_]="envelopeStatus_()"
			[envelope_]="envelope_()"
			[documentNames_]="documentNames_()"
			[recipients_]="participatingRecipients_()"
		/>
	}
}
